export default {
  default: () => import("/home/runner/work/WebSite/WebSite/layouts/default.vue")
}